import React from "react";
import { InstagramLogo, TwitterLogo, FacebookLogo } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="border-t border-forest/10 mt-24 bg-mist" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-2 space-y-4">
        <div className="flex items-center gap-3">
          <img src="/slotfy-logo.jpg" alt="Slotfy" className="w-10 h-10 rounded-lg object-cover ring-1 ring-forest/10" />
          <span className="font-heading text-2xl font-semibold text-forest">Slotfy</span>
        </div>
        <p className="text-stone max-w-md text-sm leading-relaxed">
          Encuentra tu espacio. Reserva tu hora. Cuida de ti. Wellness, fisioterapia y deporte cerca de ti, con plazas de última hora a precio reducido.
        </p>
        <div className="flex items-center gap-3 pt-2">
          <a href="#" aria-label="Instagram" className="p-2 rounded-full border border-forest/10 hover:border-sage-deep hover:text-sage-deep transition"><InstagramLogo size={18} /></a>
          <a href="#" aria-label="Twitter" className="p-2 rounded-full border border-forest/10 hover:border-sage-deep hover:text-sage-deep transition"><TwitterLogo size={18} /></a>
          <a href="#" aria-label="Facebook" className="p-2 rounded-full border border-forest/10 hover:border-sage-deep hover:text-sage-deep transition"><FacebookLogo size={18} /></a>
        </div>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-[0.2em] text-stone mb-4">Explora</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/actividades?type=yoga" className="text-forest/80 hover:text-sage-deep">Yoga</Link></li>
          <li><Link to="/actividades?type=pilates" className="text-forest/80 hover:text-sage-deep">Pilates</Link></li>
          <li><Link to="/actividades?type=fisioterapia" className="text-forest/80 hover:text-sage-deep">Fisioterapia</Link></li>
          <li><Link to="/actividades" className="text-forest/80 hover:text-sage-deep">Todas las actividades</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs uppercase tracking-[0.2em] text-stone mb-4">Slotfy</h4>
        <ul className="space-y-2 text-sm">
          <li><a href="#" className="text-forest/80 hover:text-sage-deep">Sobre nosotros</a></li>
          <li><a href="#" className="text-forest/80 hover:text-sage-deep">Para centros</a></li>
          <li><a href="#" className="text-forest/80 hover:text-sage-deep">Soporte</a></li>
          <li><a href="#" className="text-forest/80 hover:text-sage-deep">Aviso legal</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-forest/10 py-6 text-center text-xs text-stone">
      © {new Date().getFullYear()} Slotfy. Encuentra tu espacio.
    </div>
  </footer>
);

export default Footer;
